import { useStreamValue } from 'annotation-tools/utils';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { deleteCompany } from '../../../api/fetch-functions/company';
import { viewTexts } from '../../../constants/view-texts';
import { useToken } from '../../../global-state/auth-state';
import { fetchCompanyListOf } from '../../../global-state/database/company-list';
import { koumutenId$ } from '../../../global-state/router-id';
import { ICompanyType } from '../../../types/record/company';
import { ConfirmDeleteDialogTemplate } from '../confirm-delete-dialog-template/confirm-delete-dialog-template';

const vt = viewTexts.dialogs.deleteCompany;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  company: ICompanyType;
}

export const DeleteCompanyDialog: FC<Props> = memo(
  ({ open, onClose, company: companyInit }: Readonly<Props>) => {
    const message = useMemo<string[]>(() => vt.message(companyInit.name), [
      companyInit.name
    ]);

    /* event handler */

    const token = useToken();

    const koumutenId = useStreamValue(koumutenId$);

    const closeOnClick = useCallback(
      (reason: 'yes' | 'no') => {
        if (reason === 'no') {
          onClose('cancel');
        } else {
          if (
            token !== undefined &&
            koumutenId !== undefined &&
            companyInit.name !== undefined
          ) {
            deleteCompany(token)(companyInit.id).then(res => {
              if (res.type === 'success') {
                onClose('ok');
                fetchCompanyListOf(koumutenId);
              }
            });
          }
        }
      },
      [onClose, koumutenId, companyInit, token]
    );

    return (
      // TODO: 待機状態のUIを作る
      <ConfirmDeleteDialogTemplate
        title={vt.title}
        messages={message}
        open={open}
        onClose={closeOnClick}
      />
    );
  }
);

DeleteCompanyDialog.displayName = 'DeleteCompanyDialog';
